import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import useLenis from "@/hooks/useLenis";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import WhatsAppFab from "@/components/WhatsAppFab";
import ConsentBanner from "@/components/ConsentBanner";
import ScrollToTop from "@/components/ScrollToTop";
import Analytics from "@/components/Analytics";

import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Work from "@/pages/Work";
import CaseStudy from "@/pages/CaseStudy";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import NotFound from "@/pages/NotFound";

function App() {
    useLenis();
    return (
        <BrowserRouter>
            <ScrollToTop />
            <Analytics />
            <div className="App" data-testid="app-root">
                <Nav />
                <main>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/services" element={<Services />} />
                        <Route path="/work" element={<Work />} />
                        <Route path="/work/:slug" element={<CaseStudy />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/privacy" element={<Privacy />} />
                        <Route path="/terms" element={<Terms />} />
                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </main>
                <Footer />
                <WhatsAppFab />
                <ConsentBanner />
                <Toaster
                    position="bottom-right"
                    toastOptions={{
                        style: {
                            background: "#0C0C0C",
                            color: "#F4F4F0",
                            border: "1px solid #333",
                            borderRadius: 0,
                            fontFamily: "Satoshi, sans-serif",
                        },
                    }}
                />
            </div>
        </BrowserRouter>
    );
}

export default App;
